import { Component, Output, EventEmitter } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { PhotoService } from '@app/shared/services/photo.service';
import { AlertService } from '@app/shared/services/alert.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { SessionService } from '@app/shared/services/session.service';
declare var UIkit: any;
@Component({
  selector: 'app-information-reservation',
  templateUrl: './information-reservation.component.html',
  styleUrls: ['./information-reservation.component.scss']
})
export class InformationReservation {

  public user : any = {
    email: '',
    gender: 'male',
    password: '',
    firstName: '',
    lastName: '',
    societyCode: '',
    mobile: '',
    age: ''
  };
  public passwordConfirmation: string = '';
  public loadingAccountCreation: boolean = false;
  public page: number = 1;

  public idRecto : any = null;
  public idVerso : any = null;
  public drivingRecto : any = null;
  public drivingVerso : any = null;
  public validated : boolean = false;

  public loading : boolean = false;
  @Output() changed = new EventEmitter();

  public code: Array<any> = [];

  constructor(
    private userService: UsersService,
    private photoService: PhotoService,
    private alertService: AlertService,
    public session: SessionService,

    private societyService: SocietiesService
  ) {}

  ngOnInit() {
    console.log("Initialisation info Reservation")
  }

  resetVariables() {
    this.user = {
      email: '',
      gender: 'male',
      password: '',
      firstName: '',
      lastName: '',
      societyCode: '',
      mobile: '',
      age: ''
    };
    this.page = 1;
    this.passwordConfirmation = ""
    this.validated = false;
  }

  sinistre(): void {
    console.log('sinistre')
  }

  facture(): void {
    console.log('facture')
  }
}
